import { useAuth } from "@/hooks/useAuth";
import { useSessionTimeout } from "@/hooks/useSessionTimeout";

export const SessionTimeoutHandler = () => {
  const { user } = useAuth();

  // Only enable session timeout when user is logged in
  // 30 minutes of inactivity will log user out, with 2-minute warning
  useSessionTimeout({
    timeoutMinutes: 30,
    warningMinutes: 2,
    enabled: !!user,
  });

  return null;
};
